import type {
	BindingProgress,
	BindingStatus,
	PendingBindingWork,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendDocumentsModal/components/documentBindingCard.types';

const isPending = (progress: BindingProgress | undefined): boolean =>
	progress !== undefined && progress.done < progress.total;

/** Which kinds of binding work this document still has outstanding, for the card's status line. */
export const getPendingBindingWork = ({
	fields,
	signatures,
}: BindingStatus): PendingBindingWork => {
	const fieldsPending = isPending(fields);
	const signaturesPending = isPending(signatures);

	if (fieldsPending && signaturesPending) {
		return 'both';
	}
	if (fieldsPending) {
		return 'fields';
	}
	if (signaturesPending) {
		return 'signatures';
	}
	return 'none';
};
